module.exports = {
      id: "logo-full-usage",
      viewBox: "0 0 642 398",
      url: "/" + "sprite.67d9a3e87988b596c0329bae93bfba4b.svg#logo-full",
      toString: function () {
        return this.url;
      }
    }